import { restClient } from '@/Core'
import { AppConfig } from '@/Ship/Configs/AppConfig'

import type { IPasswordResetRequestResponse } from '../Contracts/IPasswordRecovery'

/**
 * Крок 1 відновлення: лист із 6-значним кодом на пошту.
 *
 * Повертає токен кроку 2. Помилку не перехоплює — пояснення сервера
 * (`serverMessage`) і HTTP-код (`serverStatus`) розбирає стор.
 *
 * Пошта йде обрізаною й у нижньому регістрі: бек шукає точний збіг, а в базі
 * пошти нормалізовані так само (`SPEC-005` §3.3).
 */
export const RequestPasswordResetTask = async (email: string): Promise<string> => {
    const response = (await restClient.post(
        AppConfig.restForgotPasswordUrl,
        { json: { email: email.trim().toLowerCase() } },
        { isPublic: true }
    )) as unknown as IPasswordResetRequestResponse | null

    if (!response?.token) {
        throw new Error('Сервер не повернув ключ відновлення. Спробуйте ще раз.')
    }

    return response.token
}
